import React from 'react';
import { FadeIn, ChapterMark } from '../ui/BasicUI';
import { KrishnaAI } from '../silhouettes/AISilhouettes';
import { ScriptureSeal } from '../scriptures/Granthalaya';

export function ChapterKrishna() {
  return (
    <section id="chapter-3" className="scene" data-yuga="dvapara" data-chapter="III — Krishna" style={{ 
      paddingTop: 140,
      position: 'relative',
      minHeight: '100vh'
    }}>
      {/* Background AI Artwork integrated into the section */}
      <KrishnaAI />

      <div className="stage" style={{ position: 'relative', zIndex: 2 }}>
        <ChapterMark
          num="III"
          yuga="Dvapara Yuga · द्वापर युग · The Age of Halves"
          deva="कृष्ण"
          name="Krishna — the dark one who plays"
          meaning="When the world's heart was breaking, the divine arrived as a friend"
        />

        <div className="prose-grid" style={{ marginTop: '20vh' }}>
          <FadeIn className="prose-block">
            <span className="label">i · the boy by the river</span>
            <h3>He was born in a prison and grew up among cows. The flute he played undid kings.</h3>
            <p className="dropcap">
              They told children stories about him before they were old enough to know what stories were. The butter-thief. The cowherd. The boy who held a mountain on one finger to shelter a village from the sky.
            </p>
          </FadeIn>
          <FadeIn className="prose-block" delay={200}>
            <span className="label">ii · the friend, the diplomat, the charioteer</span>
            <h3>And then his cousins started a war that would not stop.</h3>
            <p>
              The Pandavas and the Kauravas were family. Family is the hardest war. When every embassy failed, eighteen armies gathered on a field called Kurukshetra. And there, at the centre, in a chariot — Krishna held the reins.
            </p>
          </FadeIn>
        </div>

        <div className="pull-quote">
          "You have a right to your action. Never to its fruit."
          <span className="attribution">Bhagavad Gītā · 2.47</span>
        </div>

        <FadeIn style={{ textAlign: "center", marginTop: 30, display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 12 }}>
          <ScriptureSeal id="mahabharata" label="The Mahabharata · everything that has ever happened" hint="open the epic →" />
          <ScriptureSeal id="gita" label="The Bhagavad Gita · the song" hint="hear it →" />
          <ScriptureSeal id="puranas" label="The Puranas · the old stories" hint="open →" />
          <ScriptureSeal id="yogasutras" label="The Yoga Sutras · Patanjali's knife" hint="open →" />
        </FadeIn>

        <FadeIn className="prose-block" style={{ margin: "0 auto", maxWidth: "44em", alignItems: "center" }}>
          <span className="label">iii · what the song was for</span>
          <h3 style={{ textAlign: "center" }}>The Gita was not spoken to soldiers. It was spoken to anyone who has ever stood, frozen, on the edge of doing the right and difficult thing.</h3>
          <p style={{ textAlign: "center", margin: "0 auto" }}>
            That is why we still hear it. The chariot is everywhere. The friend is everywhere. The pause before the action is everywhere.
          </p>
        </FadeIn>
      </div>
    </section>
  );
}
